import cookieParser from 'cookie';
import type { ServerResponse } from 'http';
import Cookie from 'js-cookie';
import type { NextPageContext } from 'next';

const MINIMAL_STYLE = 'minimal';
export const MINIMAL_STYLE_COOKIE = 'minimalStyle';

const STYLE_PARAM = 'style';
const COOKIE_SET = '1';

const cookieOptions = () => {
  const isProduction = process.env.NODE_ENV === 'production';

  return {
    path: '/',
    secure: isProduction,
    sameSite: isProduction ? ('none' as const) : ('lax' as const),
    partitioned: isProduction,
  };
};

let rememberedOnClient = false;

export const rememberMinimalStyle = (isMinimalStyle: boolean) => {
  rememberedOnClient = isMinimalStyle;
};

const appendSetCookie = (res: ServerResponse, cookie: string) => {
  const existing = res.getHeader('Set-Cookie');
  const header = Array.isArray(existing) ? [...existing] : existing ? [String(existing)] : [];

  header.push(cookie);
  res.setHeader('Set-Cookie', header);
};

export const resolveMinimalStyle = (ctx: NextPageContext): boolean => {
  const style = ctx.query?.[STYLE_PARAM];
  const hasStyle = style !== undefined;
  const isMinimalStyle = style === MINIMAL_STYLE;

  if (ctx.req && ctx.res) {
    if (!hasStyle) {
      const cookies = cookieParser.parse(ctx.req.headers.cookie ?? '');
      return cookies[MINIMAL_STYLE_COOKIE] === COOKIE_SET;
    }

    appendSetCookie(
      ctx.res,
      isMinimalStyle
        ? cookieParser.serialize(MINIMAL_STYLE_COOKIE, COOKIE_SET, cookieOptions())
        : cookieParser.serialize(MINIMAL_STYLE_COOKIE, '', { ...cookieOptions(), maxAge: 0 })
    );

    return isMinimalStyle;
  }

  if (!hasStyle) {
    return rememberedOnClient || Cookie.get(MINIMAL_STYLE_COOKIE) === COOKIE_SET;
  }

  if (isMinimalStyle) {
    Cookie.set(MINIMAL_STYLE_COOKIE, COOKIE_SET, cookieOptions());
  } else {
    Cookie.remove(MINIMAL_STYLE_COOKIE, cookieOptions());
  }

  return isMinimalStyle;
};
